import gql from "graphql-tag";

export const MY_LEAVE_LEAVES_SUBSCRIPTION = gql`
  subscription leavesSubscription {
    leavesSubscription
  }
`;
